import React from 'react'

const ScrollDowm = () => {
  return (
    <div className="home__scroll">
        <a href="#about" className="home__scroll-button--flex">
        <i class="uil uil-mouse-alt-2"></i>
        <span className="home__scroll-name">Scroll Down</span>
        <i class="uil uil-arrow-down home__scroll-arrow"></i>
        </a>
    </div>
  )
}

export default ScrollDowm